import {
  Share2, Target, Search, Globe, Fingerprint, PenTool, FileText, Megaphone,
  Database, ShoppingCart, Mail, Star, GraduationCap, HeartPulse, Building2,
  ShoppingBag, UtensilsCrossed, Briefcase, Rocket, Store, Factory, Landmark,
  CalendarDays, MapPin, LayoutDashboard, Users, UserCheck, CalendarCheck,
  IndianRupee, ClipboardList, Calendar, BookOpen, Bus, MessageSquare,
  BarChart3, Smartphone, Bell, Sparkles, TrendingUp, Cog
} from "lucide-react";

export const CONTACT = {
  phone: "+91 87500 17509",
  phoneHref: "tel:+918750017509",
  whatsapp: "https://wa.me/918750017509?text=Hi%20DG%20Hubs%2C%20I%20want%20a%20free%20consultation%20for%20my%20business.",
  email: "dghubs261@gmail.com",
  emailHref: "mailto:dghubs261@gmail.com",
  location: "Delhi NCR, India",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "About", to: "/about" },
  { label: "Insights", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const MARQUEE_ITEMS = [
  "Web Development", "SEO", "Performance Ads", "Branding", "ERP Systems",
  "Social Media", "Google Ads", "Meta Ads", "Graphic Design", "E-Commerce",
  "Content Marketing", "Business Automation",
];

export const PILLARS = [
  { icon: Sparkles, title: "CREATE", desc: "Branding, Graphic Design, Websites & Content that make your business impossible to ignore." },
  { icon: TrendingUp, title: "GROW", desc: "SEO, Social Media, Google Ads & Performance Marketing that turn attention into revenue." },
  { icon: Cog, title: "AUTOMATE", desc: "ERP, Business Solutions, CRM & Digital Systems that simplify operations end to end." },
];

export const SERVICES = [
  {
    slug: "social-media-marketing", icon: Share2, title: "Social Media Marketing",
    tagline: "Build a brand people follow, engage with and buy from.",
    items: ["Social Media Strategy", "Instagram Marketing", "Facebook Marketing", "LinkedIn Marketing", "Content Planning", "Community Management", "Social Media Optimization", "Monthly Content Calendars"],
    ideal: "Brands that want consistent visibility and an engaged community.",
  },
  {
    slug: "google-ads", icon: Target, title: "Google Ads & Performance Marketing",
    tagline: "High-intent traffic, measurable conversions, controlled spend.",
    items: ["Search Ads", "Display Ads", "YouTube Ads", "Shopping Ads", "Remarketing", "Conversion Tracking", "Campaign Optimization", "Lead Generation"],
    ideal: "Businesses that need leads and sales, fast and predictably.",
  },
  {
    slug: "seo", icon: Search, title: "Search Engine Optimization",
    tagline: "Rank where your customers are already searching.",
    items: ["Technical SEO", "On-Page SEO", "Off-Page SEO", "Local SEO", "Keyword Research", "Website SEO Audit", "Google Business Profile Optimization", "Monthly SEO Reporting"],
    ideal: "Businesses building long-term, compounding organic growth.",
  },
  {
    slug: "website-development", icon: Globe, title: "Website Development",
    tagline: "Fast, modern, conversion-focused websites built to perform.",
    items: ["Business Websites", "Corporate Websites", "WordPress Websites", "E-commerce Websites", "WooCommerce", "Landing Pages", "Website Redesign", "Website Maintenance"],
    ideal: "Any business that needs a digital home that actually converts.",
  },
  {
    slug: "branding", icon: Fingerprint, title: "Branding & Brand Awareness",
    tagline: "Create a brand people remember and trust.",
    items: ["Brand Strategy", "Logo Design", "Brand Identity", "Brand Guidelines", "Marketing Collateral", "Digital Branding", "Campaign Development"],
    ideal: "New launches and businesses ready to look as good as they are.",
  },
  {
    slug: "graphic-design", icon: PenTool, title: "Graphic Design",
    tagline: "Design that stops the scroll and sells the story.",
    items: ["Social Media Creatives", "Posters", "Brochures", "Flyers", "Visiting Cards", "Presentations", "Catalogues", "Infographics", "Advertisements", "Promotional Creatives"],
    ideal: "Teams that need a steady stream of sharp, on-brand creatives.",
  },
  {
    slug: "content-marketing", icon: FileText, title: "Content Marketing",
    tagline: "Words and stories that rank, resonate and convert.",
    items: ["Social Media Content", "Website Content", "Blog Writing", "SEO Content", "Ad Copy", "Email Content", "Video Scripts"],
    ideal: "Brands that want authority, not just activity.",
  },
  {
    slug: "meta-ads", icon: Megaphone, title: "Meta Ads",
    tagline: "Facebook & Instagram campaigns engineered for ROI.",
    items: ["Facebook Ads", "Instagram Ads", "Lead Generation", "Conversion Campaigns", "Retargeting", "Audience Targeting", "Creative Testing", "Campaign Optimization"],
    ideal: "B2C brands and local businesses scaling paid social.",
  },
  {
    slug: "erp-automation", icon: Database, title: "ERP & Business Automation",
    tagline: "Run your entire institution or business from one platform.",
    items: ["School ERP", "Student Management", "Attendance Management", "Fee Management", "Examination Management", "Timetable", "Library Management", "Transport Management", "Parent Communication", "WhatsApp Alerts", "Mobile Applications", "Admin Dashboard", "Business Automation"],
    ideal: "Schools and businesses drowning in manual processes.",
    premium: true,
  },
  {
    slug: "ecommerce", icon: ShoppingCart, title: "E-commerce Solutions",
    tagline: "Stores built to sell — from first click to repeat order.",
    items: ["E-commerce Website", "Product Listing", "Payment Gateway", "Shopping Cart", "Order Management", "WooCommerce", "Marketplace Integration"],
    ideal: "Product brands ready to sell online seriously.",
  },
  {
    slug: "email-marketing", icon: Mail, title: "Email Marketing",
    tagline: "Nurture leads and win repeat business on autopilot.",
    items: ["Campaign Strategy", "Newsletter Design", "Email Automation", "Lead Nurturing", "Promotional Campaigns", "Performance Tracking"],
    ideal: "Businesses sitting on an underused customer list.",
  },
  {
    slug: "reputation-management", icon: Star, title: "Online Reputation Management",
    tagline: "Own what people see when they search your name.",
    items: ["Google Reviews", "Brand Monitoring", "Review Management", "Reputation Strategy", "Customer Engagement"],
    ideal: "Local and service businesses where trust decides the sale.",
  },
];

export const WHY = [
  { title: "One Digital Partner", desc: "Marketing, technology, branding and automation under one roof — no juggling five vendors." },
  { title: "Strategy First", desc: "Every project starts with a clear business objective, not a template." },
  { title: "Creative + Data", desc: "We combine bold creative design with measurable marketing strategy." },
  { title: "Result Focused", desc: "Campaigns built around meaningful business outcomes, not vanity metrics." },
  { title: "Scalable Solutions", desc: "Systems designed to grow with your business, from startup to enterprise." },
  { title: "Transparent Communication", desc: "Clear reporting, honest communication and full project visibility." },
];

export const PROCESS = [
  { step: "01", title: "DISCOVER", desc: "Understand your business, audience and goals." },
  { step: "02", title: "STRATEGIZE", desc: "Build the right digital strategy for your market." },
  { step: "03", title: "CREATE", desc: "Develop your brand, website, content and campaigns." },
  { step: "04", title: "LAUNCH", desc: "Launch your digital presence and marketing campaigns." },
  { step: "05", title: "OPTIMIZE", desc: "Analyse performance and continuously improve." },
  { step: "06", title: "GROW", desc: "Scale what works and build long-term growth." },
];

export const INDUSTRIES = [
  { icon: GraduationCap, name: "Education", desc: "Admissions marketing, school websites and complete School ERP systems." },
  { icon: HeartPulse, name: "Healthcare", desc: "Patient acquisition, local SEO and trust-building digital presence." },
  { icon: Building2, name: "Real Estate", desc: "Project launches, lead funnels and high-intent ad campaigns." },
  { icon: ShoppingBag, name: "E-commerce", desc: "Stores, shopping ads and retention systems that lift AOV." },
  { icon: UtensilsCrossed, name: "Hospitality", desc: "Branding, social content and review management that fill tables." },
  { icon: Briefcase, name: "Professional Services", desc: "Authority positioning and inbound lead generation." },
  { icon: Rocket, name: "Startups", desc: "Zero-to-one branding, MVPs and growth experiments." },
  { icon: Store, name: "Retail", desc: "Footfall campaigns, catalogues and festive creatives." },
  { icon: Factory, name: "Manufacturing", desc: "B2B websites, catalogues and dealer-network marketing." },
  { icon: Landmark, name: "Finance", desc: "Compliant, credibility-first digital experiences." },
  { icon: CalendarDays, name: "Events", desc: "Buzz-worthy campaigns, ticketing funnels and coverage." },
  { icon: MapPin, name: "Local Businesses", desc: "Google Business, local SEO and WhatsApp-first lead flow." },
];

export const SOLUTIONS = [
  { title: "Digital Marketing", desc: "Build visibility, reach your audience and generate leads.", to: "/services", num: "01" },
  { title: "Website & Technology", desc: "Fast, modern, conversion-focused digital experiences.", to: "/services#website-development", num: "02" },
  { title: "Branding & Creative", desc: "Create a brand people remember.", to: "/services#branding", num: "03" },
  { title: "ERP & Automation", desc: "Simplify operations and manage your business digitally.", to: "/erp", num: "04" },
];

export const STATS = [
  { value: 7, suffix: "+", label: "Years Experience" },
  { value: 100, suffix: "+", label: "Projects Delivered" },
  { value: 50, suffix: "+", label: "Brands Supported" },
  { value: 10, suffix: "+", label: "Digital Solutions" },
];

export const PROJECT_FILTERS = ["All", "Websites", "Branding", "Social Media", "Performance Marketing", "Graphic Design", "ERP"];

export const PROJECTS = [
  { name: "EduNest School ERP", category: "ERP", industry: "Education", services: "School ERP, Mobile App, WhatsApp Alerts", result: "Manual admin work reduced across 3 campuses", grad: "from-[#0D47A1] to-[#00B8D4]" },
  { name: "UrbanNest Realty", category: "Websites", industry: "Real Estate", services: "Corporate Website, Landing Pages, SEO", result: "3x more qualified site-visit enquiries", grad: "from-[#1565C0] to-[#0B2240]" },
  { name: "Aroma Café Rebrand", category: "Branding", industry: "Hospitality", services: "Brand Strategy, Logo, Collateral", result: "A full identity refresh across 5 outlets", grad: "from-[#00B8D4] to-[#0D47A1]" },
  { name: "SkillUp Coach Social", category: "Social Media", industry: "Coaching", services: "Content Calendar, Reels, Community", result: "25k engaged followers in 6 months", grad: "from-[#0B2240] to-[#1565C0]" },
  { name: "MediCare Plus Ads", category: "Performance Marketing", industry: "Healthcare", services: "Google Ads, Meta Ads, Remarketing", result: "4.2x return on ad spend", grad: "from-[#0D47A1] to-[#071A33]" },
  { name: "CraftCo Festive Campaign", category: "Graphic Design", industry: "Retail", services: "Campaign Creatives, Catalogues, Ads", result: "120+ creatives for the festive season", grad: "from-[#1565C0] to-[#00B8D4]" },
];

export const TESTIMONIALS = [
  { name: "Rohit Malhotra", company: "UrbanNest Realty", industry: "Real Estate", quote: "DG Hubs rebuilt our website and ran our launch campaigns. The quality of leads changed completely — our sales team finally trusts marketing." },
  { name: "Dr. Shalini Verma", company: "MediCare Plus", industry: "Healthcare", quote: "From Google Ads to our Google Business profile, everything is handled in one place. Patient enquiries have grown month on month." },
  { name: "Anil Kapoor", company: "EduNest Group of Schools", industry: "Education", quote: "Their School ERP digitised fees, attendance and parent communication in weeks. It feels like we hired a full technology team." },
  { name: "Priya Nair", company: "Aroma Café", industry: "Hospitality", quote: "The rebrand gave us a completely new energy. Social content is sharp, on time, and our weekend footfall shows it." },
];

export const ERP_MODULES = [
  { icon: LayoutDashboard, name: "Admin Dashboard", desc: "One command centre for your entire institution." },
  { icon: GraduationCap, name: "Student Management", desc: "Profiles, documents and academic history." },
  { icon: Users, name: "Teacher Portal", desc: "Classes, attendance and performance tools." },
  { icon: UserCheck, name: "Parent App", desc: "Real-time updates, fees and communication." },
  { icon: CalendarCheck, name: "Attendance", desc: "One-tap marking with instant reports." },
  { icon: IndianRupee, name: "Fee Management", desc: "Online collection, receipts and reminders." },
  { icon: ClipboardList, name: "Examination", desc: "Marks entry, report cards and analytics." },
  { icon: Calendar, name: "Timetable", desc: "Smart scheduling for classes and staff." },
  { icon: BookOpen, name: "Library", desc: "Catalogue, issue and return tracking." },
  { icon: Bus, name: "Transport", desc: "Routes, vehicles and live tracking." },
  { icon: MessageSquare, name: "Communication", desc: "Notices, circulars and announcements." },
  { icon: BarChart3, name: "Reports", desc: "Every metric, exportable in a click." },
  { icon: Smartphone, name: "Mobile App", desc: "Android & iOS apps for all stakeholders." },
  { icon: Bell, name: "WhatsApp Alerts", desc: "Fees, attendance and updates on WhatsApp." },
];

export const IMAGES = {
  team: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwYWdlbmN5JTIwdGVhbSUyMHRlY2glMjBvZmZpY2V8ZW58MHx8fHwxNzkwMDcwMjY5fDA&ixlib=rb-4.1.0&q=85",
  server: "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  building: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBtb2Rlcm4lMjBidWlsZGluZyUyMHJlYWwlMjBlc3RhdGUlMjBzY2hvb2x8ZW58MHx8fHwxNzkwMDcwMjY5fDA&ixlib=rb-4.1.0&q=85",
  brainstorm: "https://images.pexels.com/photos/1181346/pexels-photo-1181346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
